import React, { useState } from "react";
import { useAuth } from "../../context/AuthContext";

const PRIVACY_URL = "https://www.partysharingapp.com/privacy-policy-app";

const storageKey = (email) => `privacy_policy_accepted_${email || "default"}`;

export const hasAcceptedPrivacy = (email) =>
  localStorage.getItem(storageKey(email)) === "true";

const PrivacyPolicyModal = ({ onAccept, onDecline }) => {
  const { user } = useAuth();
  const [agreed, setAgreed] = useState(false);

  const handleAccept = () => {
    localStorage.setItem(storageKey(user?.Email), "true");
    onAccept();
  };

  return (
    <div style={styles.overlay}>
      <div style={styles.modal}>
        <div style={styles.header}>
          <h3 style={styles.title}>Privacy Policy</h3>
        </div>

        <div style={styles.body}>
          <p style={styles.text}>
            Before uploading any content, please read and accept our{" "}
            <a
              href={PRIVACY_URL}
              target="_blank"
              rel="noopener noreferrer"
              style={styles.link}
            >
              Privacy Policy
            </a>
            .
          </p>
          <p style={styles.subText}>
            By uploading photos or videos you confirm that you have the right to
            share this content and agree to how PartySharingApp processes and
            stores your media as described in the Privacy Policy.
          </p>

          <label style={styles.checkboxLabel}>
            <input
              type="checkbox"
              checked={agreed}
              onChange={(e) => setAgreed(e.target.checked)}
              style={styles.checkbox}
            />
            <span>
              I have read and agree to the{" "}
              <a
                href={PRIVACY_URL}
                target="_blank"
                rel="noopener noreferrer"
                style={styles.link}
              >
                Privacy Policy
              </a>
            </span>
          </label>
        </div>

        <div style={styles.footer}>
          <button style={styles.declineBtn} onClick={onDecline}>
            Decline
          </button>
          <button
            style={{ ...styles.acceptBtn, ...(agreed ? {} : styles.acceptBtnDisabled) }}
            onClick={handleAccept}
            disabled={!agreed}
          >
            Accept &amp; Continue
          </button>
        </div>
      </div>
    </div>
  );
};

const styles = {
  overlay: {
    position: "fixed",
    inset: 0,
    background: "rgba(0,0,0,0.55)",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    zIndex: 9999,
  },
  modal: {
    background: "#fff",
    borderRadius: 14,
    width: "100%",
    maxWidth: 480,
    boxShadow: "0 8px 32px rgba(0,0,0,0.18)",
    overflow: "hidden",
    margin: "0 16px",
  },
  header: {
    padding: "20px 24px 16px",
    borderBottom: "1px solid #f0f0f0",
  },
  title: {
    margin: 0,
    fontSize: 18,
    fontWeight: 700,
    color: "#1e1e2d",
  },
  body: {
    padding: "20px 24px",
  },
  text: {
    margin: "0 0 10px",
    fontSize: 14,
    color: "#333",
    lineHeight: 1.6,
  },
  subText: {
    margin: "0 0 20px",
    fontSize: 13,
    color: "#666",
    lineHeight: 1.6,
  },
  link: {
    color: "#6c63ff",
    textDecoration: "underline",
  },
  checkboxLabel: {
    display: "flex",
    alignItems: "flex-start",
    gap: 10,
    fontSize: 14,
    color: "#333",
    cursor: "pointer",
    lineHeight: 1.5,
  },
  checkbox: {
    marginTop: 3,
    accentColor: "#6c63ff",
    width: 16,
    height: 16,
    flexShrink: 0,
    cursor: "pointer",
  },
  footer: {
    display: "flex",
    justifyContent: "flex-end",
    gap: 12,
    padding: "16px 24px",
    borderTop: "1px solid #f0f0f0",
    background: "#fafafa",
  },
  declineBtn: {
    padding: "9px 20px",
    borderRadius: 8,
    border: "1px solid #ddd",
    background: "#fff",
    color: "#555",
    fontSize: 14,
    fontWeight: 500,
    cursor: "pointer",
  },
  acceptBtn: {
    padding: "9px 20px",
    borderRadius: 8,
    border: "none",
    background: "#6c63ff",
    color: "#fff",
    fontSize: 14,
    fontWeight: 600,
    cursor: "pointer",
  },
  acceptBtnDisabled: {
    background: "#c5c2f0",
    cursor: "not-allowed",
  },
};

export default PrivacyPolicyModal;
